export default function () {
    try {
        return JSON.parse(localStorage.getItem('recentlyCategories')) || [];
    } catch {
        return [];
    }
}
